module.exports = __webpack_public_path__ + "img/arrow-circle-left-outline-orange.3ca05778.svg";